import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { from } from 'rxjs';

// import { saveAs } from 'file-saver';

@Injectable()
export class FileService {
  constructor() {}

  // uploadTextFile(e): Observable<string> {
  //   const file = e.target.files[0];
  //   const reader = new FileReader();
  //   reader.readAsText(file);
  //   return from(new Promise((resolve, reject) => {
  //     reader.onloadend = () => resolve(reader.result as string);
  //   }));
  // }
  //
  // uploadTextFile2(file): Observable<string> {
  //   const reader = new FileReader();
  //   reader.readAsText(file);
  //   return from(new Promise((resolve, reject) => {
  //     reader.onloadend = () => resolve(reader.result as string);
  //   }));
  // }

  uploadFile(file: any): Observable<any> {
    // const file = e.target.files[0];
    const reader = new FileReader();
    const auxFile = file._files[0];
    reader.readAsDataURL(auxFile);
    return from(
      new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result);
      })
    );
  }

  // uploadKMLorKMZ(e): Observable<any> {
  //   const file: File = e.target.files[0];
  //   const reader = new FileReader();
  //   if (file.name.substring((file.name.lastIndexOf('.') + 1)) === 'kmz' ||
  //     file.name.substring((file.name.lastIndexOf('.') + 1)) === 'KMZ') {
  //     reader.readAsBinaryString(file);
  //   } else { // is KML
  //     reader.readAsText(file);
  //   }
  //   return from(new Promise((resolve, reject) => {
  //     reader.onloadend = () => resolve(reader.result);
  //   }));
  // }
  //
  // downloadFile(fileName: string, fileType: string, data: string) {
  //   const blob = new Blob([data], {type: fileType });
  //   saveAs(blob, fileName);
  // }
}
